import { useState } from 'react';
import {
  BookOpen,
  ClipboardList,
  Droplets,
  HeartPulse,
  LogOut,
  Pill,
  UserPlus,
} from 'lucide-react';
import NoteTimingMeta from './NoteTimingMeta';
import AddendumModal from './AddendumModal';
import { useSession } from '../contexts/SessionContext';
import { useLanguage } from '../contexts/LanguageContext';

const NOTE_TYPE_ICONS = {
  progress_note: BookOpen,
  vitals: HeartPulse,
  medication_admin: Pill,
  fluid_balance: Droplets,
  handover: ClipboardList,
  shift_handover: ClipboardList,
  admission: UserPlus,
  discharge: LogOut,
};

export default function SubmittedNoteCard({
  patientName,
  noteType,
  noteTypeLabel,
  note,
  onOpen,
  viewLabel,
}) {
  const { addAddendum } = useSession();
  const { t } = useLanguage();
  const [addendumOpen, setAddendumOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const resolvedName = patientName || 'Unknown Patient';
  const NoteTypeIcon = NOTE_TYPE_ICONS[noteType] || BookOpen;

  const handleSaveAddendum = (payload) => {
    if (!note?.id) return;
    setSaving(true);
    try {
      addAddendum(note.id, payload);
      setAddendumOpen(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <article className="card-surface flex items-center gap-3 p-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-mid text-sm font-bold text-primary">
          {resolvedName.charAt(0)}
        </div>

        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-gray-900" dir="auto">
            {resolvedName}
          </p>
          <div className="mt-1 flex items-center gap-1.5 text-sm font-medium text-gray-600">
            <NoteTypeIcon
              className="h-4 w-4 shrink-0 text-primary"
              strokeWidth={2}
              aria-hidden="true"
            />
            <span>{noteTypeLabel}</span>
          </div>
          <NoteTimingMeta note={note} className="mt-1" />
          <button
            type="button"
            onClick={() => setAddendumOpen(true)}
            className="mt-2 rounded-full border border-gray-300 bg-white px-2.5 py-1 text-xs font-semibold text-gray-600"
          >
            {t('addAddendumButton')}
          </button>
        </div>

        <button
          type="button"
          onClick={onOpen}
          className="shrink-0 rounded-full bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-900"
        >
          {viewLabel}
        </button>
      </article>

      <AddendumModal
        open={addendumOpen}
        onClose={() => setAddendumOpen(false)}
        onSave={handleSaveAddendum}
        saving={saving}
      />
    </>
  );
}
